

<template>
    <div class="container">
        <div class="layout-content">
            <global-header
                :school="1"
                :status="'APPLY'"
                :title="'방문예약 신청'"
            />
            <div class="content">
                <div class="desc">
                    방문 예약 신청이 완료되었습니다.<br><br>
                    승인 여부는 예약 신청내역 화면에서 확인할 수 있습니다.
                </div>
                <div class="submit-btn">
                    <button @click="handleHistory">에약 신청내역</button>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import GlobalHeader from "@/components/common/GlobalHeader.vue";
import { store } from "@/store";

export default {
    name: "ReservationComplete",
    components: { GlobalHeader },
    methods: {
        handleHistory() {
            this.$router.replace({ path: `/schools/${store.school.id}/visit/history` });
        },
    },
    mounted() {
        // 학교정보 없으면 초기화면으로 보냄
        if(!store.school.id) {
            this.$router.replace({ path: `/schools/${this.$route.params.school}/visit` });
        }
    }
};
</script>

<style scoped lang="scss">

</style>